<div class="ui-g card event-details">
  <div class="ui-g-9 ui-md-12 ui-lg-9 ui-g-12 event-details-2">
    <form [formGroup]="formIncentiveDetails">
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Incentive Id</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['engagementKey'].value }}
        </div>
        <div class="ui-md-3 ui-sm-6"><span>Engagement Status</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['enagementStatus'].value }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Request ID</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['engagementRequestID'].value }}
        </div>
        <div class="ui-md-3 ui-sm-6"><span>Request Date</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['requestDate'].value }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Incentive Name</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ incentiveName }}
        </div>
        <div class="ui-md-3 ui-sm-6"><span>Incentive Type</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['enagementType'].value }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>PMO Partner Name</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['pMOPartnerName'].value }}
        </div>
        <div class="ui-md-3 ui-sm-6"><span>PMO Customer Name</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['enagementPMOTenantName'].value }}
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-md-3 ui-sm-6"><span>Incentive Status</span></div>
        <div class="ui-md-3 ui-sm-6">
          {{ formIncentiveDetails.controls['incentiveStatus'].value }}
        </div>
      </div>
    </form>
  </div>

  <div class="ui-g-3 ui-md-3 ui-sm-12">
    <div class="livemsg">
      <p-scrollPanel [style]="{ width: '100%', height: '90px' }">
        <table>
          <tr *ngFor="let item of notes">
            <td>
              <span class="msgname">{{ item.userAlias }}</span
              ><span class="msgdate">
                {{ item.createdDate | date: 'short' : 'UTC-8' }}(PST)</span
              ><br /><span class="msgcontent">{{ item.notes }}</span>
            </td>
          </tr>
        </table>
      </p-scrollPanel>
      <form [formGroup]="formNotes" (ngSubmit)="onSubmitNotes()">
        <textarea
          pTextarea
          [rows]="2"
          pInputTextarea
          placeholder="Min 3 characters"
          minlength="3"
          maxlength="400"
          formControlName="notes"></textarea>
        <div style="position: relative; top: 4px">
          <button
            type="submit"
            tooltipPosition="bottom"
            pTooltip="Send"
            class="btnmsg">
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            tooltipPosition="bottom"
            pTooltip="Refresh"
            class="btnmsg">
            <i
              class="fa fa-refresh"
              (click)="getNotesList()"
              aria-hidden="true"></i>
          </button>
          @if (release === 'Prod') {
            <a
              target="_blank"
              href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                incentiveDetails.requestDetailId
              }}'"
              tooltipPosition="bottom"
              pTooltip="History"
              class="fa fa-history icohistory"
              aria-hidden="true">
            </a>
          }
          @if (release !== 'Prod') {
            <a
              target="_blank"
              href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                incentiveDetails.requestDetailId
              }}'"
              tooltipPosition="bottom"
              pTooltip="History"
              class="fa fa-history icohistory"
              aria-hidden="true">
            </a>
          }
        </div>
      </form>
    </div>
  </div>
</div>
